import { render, staticRenderFns } from "./approval-awaiting.vue?vue&type=template&id=e4af3696&"
import script from "./approval-awaiting.vue?vue&type=script&lang=js&"
export * from "./approval-awaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports